document.addEventListener("DOMContentLoaded", (event) => {
  toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    showDuration: "1000",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };


  window.addEventListener('DOMContentLoaded', () => {
    if (window.location.hash === 'pages') {
      history.replaceState(null, '', window.location.pathname); // Remove the hash
      window.scrollTo(0, 0); // Scroll to top
    }
  });

  
  const img = document.querySelector(".mobile-img");

  if (img) {
    // Dynamically set image source based on screen size
    const screenWidth = window.innerWidth;
    
    if (screenWidth < 768) {
      img.src = img.src.replace("1100", "375"); // Load smaller image for mobile
    } else if (screenWidth < 1024) {
      img.src = img.src.replace("1100", "750"); // Load medium image for tablets
    }

    // Lazy load image using IntersectionObserver
    if ("IntersectionObserver" in window) {
      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            let img = entry.target;
            img.src = img.dataset.src; // Load actual image
            img.classList.remove("lazy");
            observer.unobserve(img);
          }
        });
      });

      img.dataset.src = img.src; // Store actual image URL
      img.src = ""; // Prevent immediate loading
      observer.observe(img);
    }
  }



  // megamenu hovering
  // if (megamenudropdown_enable == "true") {
  //   $("header-menu details").each(function () {
  //     $(this)
  //       .mouseover(function () {
  //         $(this).attr("open", "");
  //         $(this).child("summary").attr("aria-expanded", "true");
  //       })
  //       .mouseout(function () {
  //         $(this).removeAttr("open", "");
  //         $(this).child("summary").removeAttr("aria-expanded", "true");
  //       });
  //   });
  // }
  

  // for sticky add to cart
  function StickyAddtoCart() {
    const mainproductsection = document.querySelector(".product__info-wrapper");
    const offsetTop = mainproductsection.offsetTop;
    const divHeight = mainproductsection.offsetHeight;
    const offsetBottom = offsetTop + divHeight - 400;
    const stickyAddtoDiv = document.querySelector(".variant--bottom");
    if (window.scrollY >= offsetBottom) {
      stickyAddtoDiv.classList.remove("hidden");
    } else {
      stickyAddtoDiv.classList.add("hidden");
    }
    const complemnterysection = document.querySelector(
      ".complementary-products__container"
    );
    const tabdescsection = document.querySelector(".tab-desc");
    const isMobile = window.innerWidth <= 768;
    const scrollThreshold = 900;
    if (isMobile) {
  if (window.scrollY >= scrollThreshold) {
        stickyAddtoDiv.classList.remove("hidden");
      } else {
        stickyAddtoDiv.classList.add("hidden");
      }
    }
    // hide sticky add to cart when it reahces button
    const scrolledTo = window.scrollY + window.innerHeight;
    const isReachBottom = document.body.scrollHeight === scrolledTo;
    if (isReachBottom) {
      stickyAddtoDiv.classList.add("hidden");
    }
  }
  // Add event listener for scroll
  window.addEventListener("scroll", StickyAddtoCart);
  // sticky add to basket trigger main add to basket on clciking sticky add to basket
  $("#sticky_addtocart").click(function () {
    $(this).attr("disabled");
    $("#variant_with_qty_btn").click();
  });
  // sticky add to basket end


   // for shorter description for plp product page
  const description_text = $("#short_product_desc").text().trim(" ");
  const no_of_words = $("#short_product_desc").attr("data-maxLength");
  const textlength = description_text.length;
  if (textlength > no_of_words) {
    const truncated_text = description_text.slice(0, no_of_words);
    $("#short_product_desc").text(truncated_text);
  }

  const todayDate = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  const ukDateStr = todayDate.toLocaleString("en-GB", options);
  const [datePart, timePart] = ukDateStr.split(", ");
  const [day, month, year] = datePart.split("/");
  const [hours, minutes] = timePart.split(":");
  const today = `${year}-${month}-${day} ${hours}:${minutes}`;
  window.today = today;

  // for cart message in cart page
  if (enable_cart_message === "true") {
    $(".cart-message-product").each(function () {
      const cart_message_startdate = $(this)
        .data("cartmsg-startdate")
        ?.split("T")
        .join(" ");
      const cart_message_enddate = $(this)
        .data("cartmsg-enddate")
        ?.split("T")
        .join(" ");
      const cart_message = $(this).data("cartmsg-message");
      const variantId = $(this).data("variant-id");
      if (
        today >= cart_message_startdate &&
        today <= cart_message_enddate &&
        cart_message_enddate > cart_message_startdate
      ) {
        if (cart_message) {
          $(`#cart_message_${variantId}`).val(cart_message);
        }
      } else {
        console.log("No valid cart message for variant ID:", variantId);
      }
    });
  }

  // schedule silde show
  $(".slideshow__slide").each(function () {
    var scheduled_startdate = $(this)
      .find("#scheduled_startdate")
      .text()
      .trim()
      .replace(/::/g, " ");

    var scheduled_enddate = $(this)
      .find("#scheduled_enddate")
      .text()
      .trim()
      .replace(/::/g, " ");
    const hideSlideUntil_stardate = $(this)
      .find("#additional-schedule-data")
      .data("hideslide-untildate");
    const findvideo = $(this).find("#video");
    var existingvideo = findvideo.find("source").attr("src");
    const findschdule_video = $(this).find("#scheduled_video");
    var scheduled_videoSrc = findschdule_video.find("source").attr("src");
    // const canUpload = $(this)
    //   .find("#additional-schedule-data")
    //   .data("enble-schedule"); //getting value for enable schedule uploading
    const showHideSlideOption = $(this)
      .find("#additional-schedule-data")
      .attr("data-hide-showslide"); //hide or show initial slide
    var desktopBannerImage = $(this).find("#desktop_banner_image");
    var scheduled_desktop_image = $(this).find("#scheduled_image");
    var scheduled_desktop_img_src = scheduled_desktop_image.attr("src");
    var scheduled_mobile_image = $(this).find("#scheduled_image_mobile");
    var schedule_mobile_img_src = scheduled_mobile_image.attr("src");
    if (hideSlideUntil_stardate) {
      $(this).addClass("hidden");
    } else {
      $(this).removeClass("hidden");
    }
    // if schedule startdate ,schedule end date and scheduled vide or imaga are available then start the process
    console.log(
      scheduled_startdate,
      scheduled_enddate,
      scheduled_videoSrc,
      today
    );
    if (
      scheduled_startdate &&
      scheduled_enddate &&
      (scheduled_videoSrc ||
        scheduled_desktop_img_src ||
        schedule_mobile_img_src)
    ) {
      // condition to show  slide on schedule date
      if (today >= scheduled_startdate && today <= scheduled_enddate) {
        $(this).removeClass("hidden");
        // if schedule video is available then add the video on the slide
        if (existingvideo && scheduled_videoSrc) {
          const $video = $(this).find("#video");
          $video.find("source").attr("src", scheduled_videoSrc);
          $video[0].load();
          n; //video load for initialization of new src
        }
        // for desktop image
        else if (scheduled_desktop_img_src) {
          desktopBannerImage.attr("src", scheduled_desktop_img_src);
        }
        // for mobile image
        else if (schedule_mobile_img_src) {
          const imgtag = $(this).find(".mobile-media img");
          imgtag.attr("src", schedule_mobile_img_src);
        }
      } else if (today >= scheduled_enddate) {
        $(this).remove();
        // if remove doesnot work
        $(this).addClass("hidden");
      } else {
        $(this).addClass("hidden");
      }
      // if schedule end data pass
      // else if (today >= scheduled_enddate) {
      //   if (showHideSlideOption === "hide_slide") {
      //     $(this).addClass("hidden");
      //   }
      // }
    }
  });




  
const mealdeal_main_wrapper = document.querySelectorAll('.meal-deal-main-wrapper')
  mealdeal_main_wrapper.forEach((mealdeal)=> 
    {



const mealdealcontentwrap = mealdeal.querySelectorAll('.meal-deal-main-content-wrap');

mealdealcontentwrap.forEach((contentwrap) => {
  const swiperwrapper = contentwrap.querySelectorAll('.mealdeal-swiper-slide');
  const cheviconnext = contentwrap.querySelector('.meal-deal-swiper-button-next');
  const chevicoprev = contentwrap.querySelector('.meal-deal-swiper-button-prev');
  const swiperlist = contentwrap.querySelector('.mealdeal-swipper-lists')

  if (swiperwrapper.length < 4) {
    // Hide navigation icons if slides are fewer than 4
    cheviconnext.classList.add('hidden');
    chevicoprev.classList.add('hidden');
     swiperlist.classList.add('mealdeal-swipper-lists-3');
  }

  // On mobile view (width > 640px), check if swiper has more than 2 slides
  if (window.innerWidth > 640) {
    if (swiperwrapper.length > 2) {
      cheviconnext.classList.remove('hidden');
      chevicoprev.classList.remove('hidden');
    } else {
      cheviconnext.classList.add('hidden');
      chevicoprev.classList.add('hidden');
    }
  }
  if (window.innerWidth > 320) {
    if (swiperwrapper.length > 1) {
      cheviconnext.classList.remove('hidden');
      chevicoprev.classList.remove('hidden');
      // swiperlist.classList.add('mealdeal-swipper-lists-1');
    } else {
      cheviconnext.classList.add('hidden');
      chevicoprev.classList.add('hidden');
      swiperlist.classList.add('mealdeal-swipper-lists-1');
    }
  }

  if (swiperwrapper.length == 1) {
    swiperlist.classList.add('mealdeal-swipper-lists-1');
}
  
});









      

   let selected_bundle_header;
 const selected_product_container = mealdeal.querySelector('.meal-deal-selected-product');
   const total_price_container = mealdeal.querySelector('.meal_deal_total_price');
  const toal_price_header_container = mealdeal.querySelector('.mealdeal-priceinfo-header')
     const addToCartButton = mealdeal.querySelectorAll(".mealdeal-mainaddtocart");
   const meal_deal_swipers = mealdeal.querySelectorAll('.meal-deal-product-swiper')
  const meal_deal_content_wrapper = mealdeal.querySelectorAll('.meal-deal-content-wrapper')
 meal_deal_content_wrapper[0].classList.add('active');  // Add 'active' class to the first wrapper
let finalpriceafterdiscount=0
const firstWrapper = meal_deal_content_wrapper[0];
if (firstWrapper.classList.contains('active')) { 
    const chev_up_icon = firstWrapper.closest('.meal-deal-main-content-wrap').querySelector('.meal-deal-chev-up');
    const chev_down_icon = firstWrapper.closest('.meal-deal-main-content-wrap').querySelector('.meal-deal-chev-down');
    
    chev_up_icon.classList.remove('hidden'); 
    chev_down_icon.classList.add('hidden'); 
}




const meal_deal_collapsible_header = mealdeal.querySelectorAll('.meal-deal-section-header-wrapper');

meal_deal_collapsible_header.forEach((collapsibleHeader) => {
  collapsibleHeader.addEventListener('click', () => {
    console.log('clicking header here');

    const activeContainer = collapsibleHeader.closest('.meal-deal-main-content-wrap').querySelector('.meal-deal-content-wrapper');
    const chevUp = collapsibleHeader.querySelector('.meal-deal-chev-up');
    const chevDown = collapsibleHeader.querySelector('.meal-deal-chev-down');
    const index_to_beselected = activeContainer.getAttribute('data-meal-deal-index');

    console.log('index checking active', index_to_beselected);

    // Iterate through all content wrappers
    mealdeal.querySelectorAll('.meal-deal-content-wrapper').forEach((contentWrapper) => {
      const data_attribute = contentWrapper.getAttribute('data-meal-deal-index');
      const currentHeader = contentWrapper.closest('.meal-deal-main-content-wrap').querySelector('.meal-deal-section-header-wrapper');
      const currentChevUp = currentHeader.querySelector('.meal-deal-chev-up');
      const currentChevDown = currentHeader.querySelector('.meal-deal-chev-down');

      if (index_to_beselected === data_attribute) {
        // Toggle active state for the clicked container
        if (contentWrapper.classList.contains('active')) {
          contentWrapper.classList.remove('active');
          chevDown.classList.remove('hidden');
          chevUp.classList.add('hidden');
        } else {
          contentWrapper.classList.add('active');
          chevDown.classList.add('hidden');
          chevUp.classList.remove('hidden');
        }
      } else {
        // Remove active state and reset chevrons for all other containers
        contentWrapper.classList.remove('active');
        currentChevUp.classList.add('hidden');
        currentChevDown.classList.remove('hidden');
      }
    });
  });
});

      

  

   mealdeal.querySelectorAll(".meal-deal-product-swiper").forEach((container) => {
       const swiperId = container.closest(".swiper-container").dataset.swiperId;
      new Swiper(container, {
        slidesPerView: 1.2,
        loop:false,
        spaceBetween: 20,
        loopAddBlankSlides: false,
        navigation: {
           nextEl: `.meal-deal-swiper-button-next[data-swiper-id="${swiperId}"]`,
          prevEl: `.meal-deal-swiper-button-prev[data-swiper-id="${swiperId}"]`,
        },
         breakpoints: {
   
      320:{
      slidesPerView: 1.2,
        spaceBetween: 20,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 2,
    },
   1024: {
     slidesPerView: 4,
     }
  }

        
      });
    });
   
  let totalPrice = 0;
  let selectedProducts = {}; // To store the selected products for each meal deal
   let mealdealdiscount ;


     // Quantity selector
  mealdeal.addEventListener("click", (e) => {
    if (e.target.classList.contains("quantity-plus") || e.target.classList.contains("quantity-minus")) {
      const input = e.target.closest(".meal-deal-product-quantity").querySelector(".quantity-input");
      let currentValue = parseInt(input.value, 10);

      if (e.target.classList.contains("quantity-plus")) {
        input.value = currentValue + 1;
      } else if (e.target.classList.contains("quantity-minus") && currentValue > 1) {
        input.value = currentValue - 1;
      }
    }
  });

  mealdeal.querySelectorAll('.meal-deal-product-select').forEach(button => {
    button.addEventListener('click', (event) => {
          selected_bundle_header = event.target.dataset.mealdealSelectHeader
      const mealDealId = event.target.dataset.mealdealId;
      const productId = event.target.dataset.productId;
      const updatedProductid = `gid://shopify/ProductVariant/${productId}`
      const producthandle = event.target.dataset.mealdealProductHandle;
      const productTitle = event.target.dataset.productTitle;
      const productPrice = parseFloat(event.target.dataset.productPrice);
      const meal_deal_title = event.target.dataset.mealdealTitle;
      const meal_deal_discount = event.target.dataset.mealdealDiscount;
      const meal_deal_section_title  = event.target.dataset.sectionMealdealTitle
      const meal_deal_category_title = event.target.dataset.mealdealCategoryTitle;
       const product_btnlabel = event.target.dataset.mealdealProductbtnlabel;
      // add active class to next carousel
      const meal_deal_selected_carousel = button.closest('.meal-deal-content-wrapper')
      const selected_header  = button.closest('.meal-deal-main-content-wrap').querySelector(`.meal-deal-selected-item-header[data-selected-header="${meal_deal_category_title}"]`)
       
      if(button.classList.contains('mealdeal-selected') || button.textContent.trim() === 'Remove')
      {
        delete selectedProducts[meal_deal_category_title];
        button.classList.remove('mealdeal-selected');
          button.textContent = product_btnlabel;
        
        selected_header.classList.add('mealdeal-removed')
    $(selected_product_container).find('.product-item[data-product_mealdeal="' + meal_deal_category_title + '"]')
  .remove();
      selected_header.textContent=` `
      }
      else 
      {
        if (selectedProducts[meal_deal_category_title]) {
          // alert(`You have already selected a product for ${event.target.dataset.mealdealTitle}.`);
         toastr.warning(`You have already selected a product for ${event.target.dataset.mealdealCategoryTitle}.`)
          return;
        }
          button.classList.add('mealdeal-selected')
      button.textContent = 'Remove'
      selected_header.classList.remove('mealdeal-removed')
      const meal_deal_selected_carousle_index = meal_deal_selected_carousel.getAttribute('data-meal-deal-index');
      const meal_deal_tobeselected_carousel = parseInt(meal_deal_selected_carousle_index, 10) + 1;
      const meal_deal_to_select = mealdeal.querySelector(`.meal-deal-content-wrapper[data-meal-deal-index="${meal_deal_tobeselected_carousel}"]`);
          const meal_deal_content_wrappers = mealdeal.querySelectorAll('.meal-deal-content-wrapper');
      

      meal_deal_content_wrappers.forEach((meal_deal_carousel, index) => {
      if (index == meal_deal_selected_carousle_index) {
        console.log('index', index,meal_deal_tobeselected_carousel)
        console.log('addeed calss active')
        meal_deal_carousel.classList.add('active');
        const chev_down_icon = meal_deal_carousel.closest('.meal-deal-main-content-wrap').querySelector('.meal-deal-chev-down')
         const chev_up_icon = meal_deal_carousel.closest('.meal-deal-main-content-wrap').querySelector('.meal-deal-chev-up')
        chev_up_icon.classList.remove('hidden')
         chev_down_icon.classList.add('hidden')
        console.log('meal deal after added active',meal_deal_carousel)
      } else {
        meal_deal_carousel.classList.remove('active');
         const chev_down_icon = meal_deal_carousel.closest('.meal-deal-main-content-wrap').querySelector('.meal-deal-chev-down')
         const chev_up_icon = meal_deal_carousel.closest('.meal-deal-main-content-wrap').querySelector('.meal-deal-chev-up')
        chev_up_icon.classList.add('hidden')
         chev_down_icon.classList.remove('hidden')
      }
    });
      console.log('meal deal to select checking',meal_deal_to_select)

  
      console.log('category title checking',meal_deal_category_title)
      mealdealdiscount = meal_deal_discount;
      const meal_deal_featured_image = event.target.dataset.mealdealImage;
       const quantity = button
      .closest(".meal-deal-product-card-inner")
      .querySelector("input").value;
      selected_header.textContent=` ${productTitle}`
      

      if (!selectedProducts[meal_deal_category_title]) {
        // If no product has been selected for this meal deal, select this one
        selectedProducts[meal_deal_category_title] = {updatedProductid,producthandle, productId,meal_deal_section_title, productTitle,quantity,meal_deal_category_title, productPrice,meal_deal_title,meal_deal_featured_image,meal_deal_discount};
    

          totalPrice += productPrice * quantity;
        const totalDiscount = (totalPrice * meal_deal_discount) / 100;
        const finalPriceAfterDiscount = totalPrice - totalDiscount;
        console.log("Selected Products:", selectedProducts);
        console.log("Total Price (Before Discount):", totalPrice.toFixed(2));
        console.log("Total Discount:", totalDiscount.toFixed(2));
        console.log("Final Price (After Discount):", finalPriceAfterDiscount.toFixed(2));
        
        console.log(`Total Price: ${totalPrice}`);
        updatePrice(totalPrice,finalPriceAfterDiscount,totalDiscount)
        
       // button.textContent = "";
        button.disabled = true;
      
          setTimeout(() => {
          button.disabled = false;
          // button.textContent = "Select";
        }, 1000);

       renderSelectedProducts(true)
        toastr.success(`You selected ${productTitle}`)
        // scrollToSelectedProducts()
      // Enable the 'Add to Cart' button if all meal deals have a selected product
    };
      }
    

      console.log('sfdsdkfjdsfk dfj sdkfj dsf0000',selectedProducts)
  });
  })

     

     function renderSelectedProducts(render_title) {
       console.log('rendering selected prodcut')
    selected_product_container.innerHTML = ''; // Clear existing products
       if(render_title){
       if (!selected_product_container.querySelector('.selected-product-title')) {
        selected_product_container.innerHTML = `<h4 class='selected-product-title'>${selected_bundle_header}</h4>`;
    } else {
        console.log('.selected-product-title already exists');
    }
        }
    Object.keys(selectedProducts).forEach((key) => {
      
      const product = selectedProducts[key];
      console.log('rendeirng checking',product)
      // Create product item
      const productDiv = document.createElement('div');
      productDiv.classList.add('product-item');
      productDiv.dataset.productId = product.productId;
       productDiv.dataset.product_mealdeal = product.meal_deal_category_title;
      productDiv.innerHTML = `
        <span class='meal-deal-selected-product-category'> ${product.meal_deal_category_title}: </span>
        <span class="product-title">${product.productTitle}</span>
        <button data-product-price="${product.productPrice}" data-meal-title='${product.meal_deal_category_title}' class="meal-deal-product-remove">Remove</button>
      `;

      // Add product item to container
      selected_product_container.appendChild(productDiv);



  // Remove button functionality
  mealdeal.querySelectorAll('.meal-deal-product-remove').forEach(button => {
    button.addEventListener('click', (event) => {
      const mealDealTitle = event.target.dataset.mealTitle;
       console.log('its meal deal title',mealDealTitle)
      const productPrice = selectedProducts[mealDealTitle].productPrice;
      const quantity = selectedProducts[mealDealTitle].quantity;

const selected_header = mealdeal.querySelector('.meal-deal-main-content-wrap .meal-deal-selected-item-header[data-selected-header="' + mealDealTitle + '"]');
selected_header.textContent = '';

      const selected_remove_button = mealdeal.querySelectorAll('.meal-deal-product-card-wrapper');
      selected_remove_button.forEach((card)=>
        {
          const relatedbutton = card.querySelector('.meal-deal-product-select[data-mealdeal-category-title="' + mealDealTitle + '"]')
          console.log('realted button',relatedbutton)
          if(relatedbutton)
          {
            relatedbutton.textContent ='Add'
          }
          
        })
selected_header.textContent = '';

      
      // Remove the selected product and update the total price
      delete selectedProducts[mealDealTitle];
      totalPrice -= productPrice * quantity;
        const totalDiscount = (totalPrice * mealdealdiscount) / 100;
        const finalPriceAfterDiscount = totalPrice - totalDiscount;

      // Enable the buttons in the meal deal
      mealdeal.querySelectorAll(`.meal-deal-content-wrapper[data-mealdeal-id="${mealDealTitle}"] .meal-deal-product-select`)
        .forEach(button => {
          button.disabled = false;
          button.innerText = 'Select'; // Change text back to 'Select'
        });

      // Update the total price and check if all products are selected
        updatePrice(totalPrice,finalPriceAfterDiscount,totalDiscount)

           const selectedProductLength = Object.keys(selectedProducts).length;
       console.log('selected prodcu lenght',selectedProductLength)
   if (selectedProductLength == 0) {
      $('.selected-product-title').text('');
       renderSelectedProducts(false)
    }
      else 
   {
     renderSelectedProducts(true)
   }
      
    });
     });
      
    });

  }

     function formatAmount(amount) {
    // Format the amount to two decimal places
    const formattedAmount = (amount / 100).toFixed(2);
    const dukeshill_currency_symbol = `£${formattedAmount}`;
    return dukeshill_currency_symbol;
    }


   function scrollToSelectedProducts() {
  const selectedProductsDiv = mealdeal.querySelector('.meal-deal-selected-product');
  if (selectedProductsDiv) {
    selectedProductsDiv.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  } else {
    console.error('Selected products section not found.');
  }
}

   function updatePrice(total_price,finalPriceAfterDiscount,totalDiscount){
    finalpriceafterdiscount = finalPriceAfterDiscount
     if(total_price > 0)
     {
    const formated_amount = formatAmount(finalPriceAfterDiscount)
       const savedAmount = formatAmount(totalDiscount)
           //  total_price_container.innerHTML = `<div class='meal-deal-totalprice-header'> Total Amount ${formated_amount}. <span class='meal-deal-saved-price'> (You saved ${savedAmount}) </span>  </div>`;

           // toal_price_header_container.innerHTML = `<div class='meal-deal-totalprice'> Total Amount ${formated_amount}. <span class='meal-deal-saved-price'> (You saved ${savedAmount}) </span>  </div>`;
     }
     else 
     {
        total_price_container.innerHTML = '';
       toal_price_header_container.innerHTML = '';
     }
   }




      

addToCartButton.forEach((button)=>
  {
       button.addEventListener("click", (event) => {
     const selectedProductLength = Object.keys(selectedProducts).length;

  if ( meal_deal_swipers.length != selectedProductLength) {
    // alert("Please select products before adding to cart.");
    toastr.warning('Please select a product from each category before adding to cart.')
    return;
  }
           const total_price_of_bundle = $(event.target).data("mealdealTotalprice")
         const updatePrice = parseInt(total_price_of_bundle)
       const delivery_date_from = $(event.target).data("mealdealDeliverydatefrom");
          const delivery_date_to = $(event.target).data("mealdealDeliverydateto");
      const featured_image_pr = $(event.target).data("mealdealFeaturedimage");
      const mealdeal_title_main = $(event.target).data("mealdealTitle");

     const updatedProductIds = Object.values(selectedProducts).map((product) => product.updatedProductid);
         const updatedhandle = Object.values(selectedProducts).map((product) => product.producthandle);
  const uniqueId = `cartItem-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
     const main_product_id = $(event.target).data('mealdealMainproductid');
const itemLength = updatedProductIds.length; 
const totalPrice = parseFloat(total_price_of_bundle); 
const regularPrice = parseFloat((totalPrice / itemLength).toFixed(2));
const roundedTotal = regularPrice * itemLength;
const difference = parseFloat((totalPrice - roundedTotal).toFixed(2));
const adjustedPrice = difference === 0 ? 0 : parseFloat((regularPrice + difference).toFixed(2));
console.log("Regular Price (for all items):", regularPrice);
console.log("Adjusted Price (for first item):", adjustedPrice);



    const cartItems = [
  {
    id: main_product_id,
    quantity: 1,
    properties: {
      _mealdeal_bundle_identifier:uniqueId,
      _mealdeal_bundle_title: mealdeal_title_main,
      _mealdeal_bundle_parentvariantid: updatedProductIds, 
      _mealdeal_bundle_discountprice: updatePrice,
      _mealdeal_bundle_image: featured_image_pr,
      _mealdeal_delivery_date_from : delivery_date_from,
      _mealdeal_delivery_date_to: delivery_date_to,
      _mealdeal_products_handle : updatedhandle,
       _mealdeal_adjusted_price : adjustedPrice,
      _mealdeal_regular_price : regularPrice
    },
  
  },
];


  // Debugging: Log cart items
  console.log("Items to be added to cart:", cartItems);


  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items: cartItems }),
  })
     .then((response) => response.json())
      .then((response) => {
      // Success response
      console.log("Products successfully added to cart:", response);
      selectedProducts = {};
      renderSelectedProducts(true)
     $('.meal-deal-totalprice').empty();
      $('.selected-product-title').empty();
      $(mealdeal).find('.meal-deal-selected-item-header').empty()
      toastr.success('Products Added Successfully')
        
    $('cart-drawer').removeClass('is-empty')




// Fetch the cart data
fetch('/cart.js')
  .then(response => {
    if (!response.ok) {
      throw new Error('Failed to fetch cart data.');
    }
    return response.json();
  })
  .then(cartData => {
    // Get the updated cart length
    const updatedCartLength = cartData.items.length;

    // Update the cart count bubble
    $('.cart-count-bubble').text(updatedCartLength);

    console.log('Cart updated successfully. Items in cart:', updatedCartLength);
  })
  .catch(error => {
    console.error('Error fetching cart data:', error);
  });



        
        

    fetch('/?section_id=cart-drawer')
  .then((response) => response.text())
  .then((html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Find the new cart drawer in the fetched HTML
    const updatedCartDrawer = tempDiv.querySelector(".cart-drawer");
    
    if (updatedCartDrawer) {
      // Find the existing cart drawer in the current DOM
      const existingCartDrawer = document.querySelector(".cart-drawer");
      
      if (existingCartDrawer) {
        existingCartDrawer.replaceWith(updatedCartDrawer);
      } else {
        console.error("Existing cart drawer not found in the current DOM.");
      }
    } else {
      console.error("Updated cart drawer not found in the fetched HTML.");
    }
  })
  .catch((error) => console.error("Error fetching and updating the cart drawer:", error));



        
    
     
     
    })
    .catch((error) => {
      // Error handling
      console.error("Error adding products to cart:", error);
    
    });
});
  })



 })


     document.addEventListener('click', function (e) {
    if (e.target.classList.contains('card-information-general-addtocart-icon')) {
      console.log('yes it contains')
        e.preventDefault();
        console.log('add to cart icon clicked 00000');

        let pc_wrapper = e.target.closest('.card--general'); // Adjust the wrapper class if needed
        console.log('pc wrapper checking', pc_wrapper);

        if (pc_wrapper) {
            pc_wrapper.querySelector(".card-information-general-top-info")?.classList.add("general-card-hidden");
            pc_wrapper.querySelector('.card-information-general-cross-icon')?.classList.remove('hidden');
            pc_wrapper.querySelector('.card-information-general-addtocart-icon')?.classList.add('hidden');
        }
    }
});

     document.addEventListener('click', function (e) {
    if (e.target.classList.contains('card-information-general-cross-icon')) {
        e.preventDefault();
        let pc_wrapper = e.target.closest('.card--general'); // Adjust the wrapper class if needed
        console.log('pc wrapper checking', pc_wrapper);

        if (pc_wrapper) {
            pc_wrapper.querySelector(".card-information-general-top-info")?.classList.remove("general-card-hidden");
            pc_wrapper.querySelector('.card-information-general-addtocart-icon')?.classList.remove('hidden');
            pc_wrapper.querySelector('.card-information-general-cross-icon')?.classList.add('hidden');
        }
    }
});

  
});
